function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#FFF",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M6 0C2.692 0 0 2.839 0 6.328c0 1.18.31 2.33.896 3.328l4.762 8.095c.092.155.252.249.425.249h.004a.495.495 0 0 0 .425-.256l4.642-8.174A6.585 6.585 0 0 0 12 6.328C12 2.838 9.308 0 6 0zm4.296 9.029l-4.22 7.43L1.746 9.1a5.482 5.482 0 0 1-.753-2.772c0-2.908 2.25-5.28 5.007-5.28 2.757 0 5.003 2.372 5.003 5.28 0 .954-.247 1.888-.707 2.7z"
}), React.createElement("path", {
  d: "M6.046 3.21c-1.654 0-3 1.42-3 3.163 0 1.732 1.324 3.162 3 3.162 1.697 0 3-1.449 3-3.162 0-1.744-1.346-3.162-3-3.162zm0 5.278c-1.108 0-2.007-.95-2.007-2.115 0-1.162.904-2.115 2.007-2.115 1.103 0 2.003.953 2.003 2.115 0 1.148-.877 2.115-2.003 2.115z"
}));

var SvgPlaceholder = function SvgPlaceholder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 12,
    height: 18,
    viewBox: "0 0 12 18",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPlaceholder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/placeholder.8a69c39b.svg";
export { ForwardRef as ReactComponent };